import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { VGAGasData } from "../models/vgsgas.model";
import { SiteList } from "../models/site.model";
import { environment } from "../environments/environment";

@Injectable({
    providedIn: 'root',
})
export class VGAGasService {
    baseSiterUrl = environment.baseUrl;
    constructor(private http: HttpClient) { }

    getVGSGasData(date:string): Observable<VGAGasData[]> {
        var url = `${this.baseSiterUrl}vgagas/${date}`;
        return this.http.get<VGAGasData[]>(url);
    }
    saveVGSGasData(formData: any): Observable<any> {
        var url = `${this.baseSiterUrl}vgagas`;
        return this.http.post<any>(url, formData);
    }
}